import { render, staticRenderFns } from "./StatContrats.vue?vue&type=template&id=33ba5e7b&"
import script from "./StatContrats.vue?vue&type=script&lang=js&"
export * from "./StatContrats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports